import { ItemsConfig } from "@services/tracpage/types/trac-page-items-config";
import { SectionIdentifier } from "@services/tracpage/types/trac-page-section-id";

export const EMPTY_ITEMS_CONFIG: ItemsConfig = {
  [SectionIdentifier.MUSIC]: {},
  [SectionIdentifier.MERCH]: {},
  [SectionIdentifier.EVENTS]: {},
};
